import useSearchParams from './useSearchParams';

// True whenever this page shouldn't show its own app chrome or run chrome-only
// background work (notification/open-cases polling, sidebar/nav data): either
// it's rendered inside an iframe (`window.self !== window.top`, true on ANY
// route reached via an embedded module — no per-link `?embed=1` needed), or
// `?embed=1` was set explicitly (forcing bare mode without an actual iframe).
function useIsEmbedded(): boolean {
  const [[embed]] = useSearchParams({ embed: null });
  const isInIframe = typeof window !== 'undefined' && window.self !== window.top;
  return isInIframe || embed === '1' || embed === 'true';
}

export default useIsEmbedded;
